import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import V2Ru from "@/components/v2/V2Ru.vue";
import V2En from "@/components/v2/V2En.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'V2View',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$i18n.locale === 'ru')
      ? (_openBlock(), _createBlock(V2Ru, { key: 0 }))
      : (_openBlock(), _createBlock(V2En, { key: 1 }))
  ]))
}
}

})